import type React from 'react';

import { setClass } from '../../helpers/utils';
import { LoadingSpinner } from '../LoadingSpinner';
import './styles.scss';

type ButtonProps = {
	className?: string;
	loading?: boolean;
	onClick?: React.MouseEventHandler<
		HTMLButtonElement | HTMLAnchorElement
	> | null;
	href?: string;
	disabled?: boolean;
	type?: 'button' | 'submit' | 'reset';
	text?: React.ReactNode;
	children?: React.ReactNode;
	variant?: string;
	size?: string;
	style?: React.CSSProperties;
};

export const Button = ({
	className = '',
	loading,
	onClick = null,
	href,
	disabled,
	type = 'button',
	text,
	children,
	variant = 'primary',
	size = '',
	style,
}: ButtonProps) => {
	const typeVariant = {
		primary: 'is-primary',
		secondary: 'is-secondary',
		success: 'is-success',
		warning: 'is-warning',
		danger: 'is-danger',
		neutral: 'is-neutral',
	};

	const typeSize = {
		default: 'is-default',
		medium: 'is-medium',
		small: 'is-small',
		xsmall: 'is-xsmall',
	};

	const isLoading = loading ? 'is-loading' : '';
	const isVariant = typeVariant[variant] || '';
	const isSize = typeSize[size] || '';

	return href ? (
		<a href={href} onClick={onClick} className={`btn ${className}`}>
			{text || children}
		</a>
	) : (
		<button
			disabled={disabled}
			type={type}
			onClick={onClick}
			className={setClass(`btn
        ${isVariant}
        ${isSize}
        ${isLoading}
        ${className}`)}
			style={style}
		>
			<span className="btn__label">{text || children}</span>
			{loading && <LoadingSpinner />}
		</button>
	);
};
